export const urls = {
  termsOfService: 'https://www.captur.ai/terms-of-service',
  privacyPolicy: 'https://www.captur.ai/privacy-policy',
  helpCenter: 'https://intercom.help/captur-db0de09e811e/en'
};
